import React, { Component } from 'react';
import E from 'wangeditor';
import { apiHost } from '../../utils/constant';
import userStorage from '../../utils/storage';
class Wangeditor extends Component {
  static getDerivedStateFromProps(nextProps) {
    // Should be a controlled component.
    if ('value' in nextProps) {
      return {
        ...(nextProps.value || {})
      };
    }
    return null;
  }
  constructor() {
    super();
    this.state = {
      html: ''
    };
    this.editor = null;
    this.loadedContent = false;
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.editor = new E('#editor');
    this.editor.customConfig = {
      uploadImgShowBase64: true,
      uploadImgServer: `${apiHost}/admin/api/uploadImg`,
      uploadImgHeaders: {
        token: userStorage.token
      },
      uploadFileName: 'file',
      uploadImgHooks: this.uploadImgHooks(),
      onchange: html => {
        this.setState({ html: html });
        this.handleChange({ html: html });
      }
    };
    this.editor.create();
  }

  componentDidUpdate() {
    if (this.state.html !== '') {
      if (this.props.isLoadedContent === false) {
        this.editor.txt.html(this.state.html);
        this.props.loadedContent(true);
      } else {
        if (!this.loadedContent) {
          this.editor.txt.html(this.state.html);
          this.loadedContent = true;
        }
      }
    }
  }

  uploadImgHooks = () => {
    return {
      before: (xhr, editor, files) => {
        // 图片上传之前触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件
        // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
        // return {
        //     prevent: true,
        //     msg: '放弃上传'
        // }
        console.log(files);
      },
      success: (xhr, editor, result) => {
        // 图片上传并返回结果，图片插入成功之后触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
      },
      fail: (xhr, editor, result) => {
        // 图片上传并返回结果，但图片插入错误时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
      },
      error: (xhr, editor) => {
        // 图片上传出错时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
      },
      timeout: (xhr, editor) => {
        // 图片上传超时时触发
        // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
      },

      // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
      // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
      customInsert: function(insertImg, result, editor) {
        // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
        // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

        // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
        var url = result.url;
        insertImg(url);

        // result 必须是一个 JSON 格式字符串！！！否则报错
      }
    };
  };
  handleChange(value) {
    console.log(value);
    this.triggerChange(value);
  }
  triggerChange = changedValue => {
    const onChange = this.props.onChange;
    if (onChange) {
      onChange(Object.assign({}, this.state, changedValue));
    }
  };
  render() {
    return (
      <div>
        <div id="editor" />
        <input
          type="hidden"
          onChange={this.handleChange}
          value={this.state.html}
        />
      </div>
    );
  }
}

export default Wangeditor;
